import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailBrandsChildProps as Props } from './types';
import type { CompanyBrandName } from '../../../types/companyDetail';
import { getShowBrandSummary } from '../../../services/brands';

export const Component: FunctionComponent<Props> = (props) => {
  const [name, setName] = useState<CompanyBrandName | undefined>(undefined);
  const [image, setImage] = useState<string | undefined>(undefined);

  useEffect(() => {
    let abort = false;

    const fetchBrand = async () => {
      try {
        const response = await getShowBrandSummary(props.id);
        if (!abort) {
          setName(response.name);
          setImage(response.image ?? undefined);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchBrand();
    return () => {
      abort = true;
    };
  }, [props.id]);

  return (
    <Presentation
      {...props}
      name={name}
      image={image}
    />
  );
};
